import React from "react";
import { TouchableOpacity, View, Image } from "react-native";
import button_exit from "../assets/img/icons/button_exit.png";
import HelpLinkModalTrigger from "../modals/HelpLinksModal";
import MainStyle from "../../MainStyle";
import mainStyle from "../../MainStyle";

type Props = { onExit: () => void };

const SupportGuideButtonMenu = (props: Props) => (
  <View style={[MainStyle.absolute, MainStyle.r_56, MainStyle.b_47]}>
    <View style={MainStyle.m_b_34}>
      <HelpLinkModalTrigger page="support_guide" size={48} />
    </View>

    <TouchableOpacity onPress={props.onExit}>
      <Image
        source={button_exit}
        style={[MainStyle.w_48, mainStyle.h_48]}
        resizeMode="contain"
      />
    </TouchableOpacity>
  </View>
);

export default React.memo(SupportGuideButtonMenu);
